import { Component, OnInit } from '@angular/core';
import { MultiMarketComponent } from '../multi-market.component';
import { MessageService } from 'src/app/@shared/message/message.service';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/@shared/services/common.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-d-multi-market',
  templateUrl: './d-multi-market.component.html',
  styleUrls: ['./d-multi-market.component.css']
})
export class DMultiMarketComponent extends MultiMarketComponent implements OnInit {

  constructor(public service: WebserviceService, 
    public _common: CommonService,
    public router: Router,
    public _message: MessageService,protected modalService: BsModalService) {
    super(service,_common,router,_message,modalService);
    this.constructorCallData();
   }

  ngOnInit(): void {
    this.getData();
  }

}
